import React from 'react';

export const Loader = () => {
    return (<div className="loading">Loading&#8230;</div>)
}
